import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useIdleTimer = (timeout = 1200000) => {
  // 20 minutes in milliseconds  1200000
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = () => {
      navigate("/Logout");
    };

    let timer;

    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(handleLogout, timeout);
    };

    const events = ["mousemove", "keydown", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // Initialize timer on mount

    return () => {
      if (timer) clearTimeout(timer);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [navigate, timeout]);
};

export default useIdleTimer;
